export default {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 5
  },
  button: {
    margin: [5, 10]
  }
};
